import Head from 'next/head'
import styles from '../../../styles/index.module.css'
import { Services } from '../../../components/index/service/Services'
import { RequestProvider } from '../../../context/RequestContext'
import { countryList } from '../../../utils/constants'
import { getRequestJSON } from '../../../api/index/location-api'
import Script from 'next/script'
import { useRouter } from 'next/router'

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps({params}) {
  const countryCd = params.countryCd
  const locality = params.locality

  let countryName;
  let currencyCd;
  let countryDescription;

  const getCountryDetails = () => {
      if(countryCd === "undefined" || locality === "undefined"){
          countryName = "Singapore"
          currencyCd = "SGD"
      } else {
          for(let x in countryList){
              if(countryCd === countryList[x].country_cd){
                  countryName = countryList[x].country_name
                  currencyCd = countryList[x].country_curr_cd
                  countryDescription = countryList[x].country_description
                  return
              }
          }
      }
  }

  getCountryDetails()

  const requestCategorySettings = await getRequestJSON(countryName)

  return {
      props: {
        requestCategorySettings,
        countryName,
        countryDescription
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// the path has not been generated.
export async function getStaticPaths() {
    
    // Get the paths we want to pre-render based on posts
    const paths = countryList.map((country) => 
    ({
      params: { countryCd: country.country_cd},
    })).flat()

    // We'll pre-render only these paths at build time.
    // { fallback: blocking } will server-render pages
    // on-demand if the path doesn't exist.
    return { paths, fallback: false }
}

export default function Home(props) {
  
  const router = useRouter()
  const countryName = props.countryName
  const locality = props.locality
  const countryDescription = props.countryDescription
  const requestType = router.query.requestType
  const requestCategorySettings = props.requestCategorySettings.filter(category => category.requestType === requestType)

  return (
    <>
      <Head>
        <title>{`Request for any service in ${locality}, ${countryName}`}</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content={`Request for any service in ${locality}, ${countryName} - Property Agent, Financial Advisor, Personal trainer, Handyman, Domestic helper, Aircon servicing, Food Caterer, Interior Designer and many more...`}/>
        <meta name="keywords" content="House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner"/>
        <meta name="author" content="StringsSG"/>
        <meta name="robots" content="noindex"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:url"   content="https://www.stringssg.com" />
        <meta property="og:type"   content="website" />
        <meta property="og:title"    content={`Request for any service in ${locality}, ${countryName}`} />
        <meta property="og:description" content="Request for a Property Agent, Financial Advisor, Personal trainer, Handyman, Domestic helper, Aircon servicing, Food Caterer, Interior Designer and many more..." />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/"/>
        <meta name="twitter:title" content={`Request for any service in ${locality}, ${countryName}`}/> 
        <meta name="twitter:description" content="Request for a Property Agent, Financial Advisor, Personal trainer, Handyman, Domestic helper, Aircon servicing, Food Caterer, Interior Designer and many more..."/>
        <link rel="icon" href="/favicon.ico" />
      </Head>  
        <div className="pt-10 pb-20">
           <RequestProvider>
                <Services requestCategorySettings={requestCategorySettings} requestType={requestType} countryName={countryName} countryDescription={countryDescription}/>
           </RequestProvider>
        </div>
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
        /> 
        <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
